// Modals
export const UPDATE_EMAIL_BALANCE = 'UPDATE_EMAIL_BALANCE';
export const UPDATE_SMS_BALANCE = 'UPDATE_SMS_BALANCE';
export const UPDATE_NOTIFICATION_BALANCE = 'UPDATE_NOTIFICATION_BALANCE';

export const SET_CD_BALANCE = 'ADD_CD_BALANCE';
export const SET_EMAIL_BALANCE = 'SET_EMAIL_BALANCE';
export const SET_SMS_BALANCE = 'SET_SMS_BALANCE';
export const SET_NOTIFICATION_BALANCE = 'SET_NOTIFICATION_BALANCE';